import { render } from "./PaymentFee.vue?vue&type=template&id=699eb201&scoped=true"
import script from "./PaymentFee.vue?vue&type=script&lang=js"
export * from "./PaymentFee.vue?vue&type=script&lang=js"

import "./PaymentFee.vue?vue&type=style&index=0&id=699eb201&lang=scss&scoped=true"
import "./PaymentFee.vue?vue&type=style&index=1&id=699eb201&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699eb201"]])

export default __exports__